import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import { CenteredContainer, Title, Text } from '@nerdwallet/currency';
import CompanyMission from '../employee-branding/company-mission/company-mission';
import ValuesModule from '../employee-branding/values-module/values-module';
import CompanyFooter from '../employee-branding/company-footer/company-footer';

import CompanyMissionText from '~/client/lib/employee-branding/splash-copy';
import ValuesModuleMobileContent from '~/client/lib/employee-branding/values-module-content-mobile';
import ValuesModuleDesktopContent from '~/client/lib/employee-branding/values-module-content-desktop';

import { CAREERS_TEAMS_PATH } from '~/client/lib/employee-branding/careers-breadcrumbs-paths';

const CompanyPage = () => (
  <div>
    <CompanyMission {...CompanyMissionText} />
    <CenteredContainer>
      <Title
        size="small"
        className={classNames([
          'companyPageValuesHdr',
          classes('margin-top-5'),
          classes('margin-bottom-3'),
          classes('margin-bottom-4--wide'),
          classes('margin-horizontal-auto'),
          classes('text-align-center'),
        ])}
        component="h2"
      >
        Our values
      </Title>
      <div
        className={classNames([
          'companyPageValuesHdr',
          classes('margin-top-0'),
          classes('margin-bottom-5'),
          classes('margin-horizontal-auto'),
          classes('text-align-center'),
          classes('width-two-thirds--wide'),
        ])}
      >
        <Text>
          Our values shape everything we do. They&#39;re not just words written
          on a wall, but lived and breathed every day by every Nerd.
        </Text>
      </div>
    </CenteredContainer>
    <div
      className={classNames([
        classes('display-block'),
        classes('display-none--wide'),
        classes('margin-bottom-5'),
      ])}
    >
      <ValuesModule {...ValuesModuleMobileContent} isMobile />
    </div>
    <div
      className={classNames([
        classes('display-none'),
        classes('display-block--wide'),
        classes('margin-bottom-5--wide'),
      ])}
    >
      <ValuesModule {...ValuesModuleDesktopContent} isMobile={false} />
    </div>
    <CompanyFooter
      backgroundColor="#EEF7FF"
      contrastColor="#9DCDFA"
      title="Come nerd out with us"
      ctaText="see open positions"
      ctaUrl={CAREERS_TEAMS_PATH}
      imageUrlMobile="https://www.nerdwallet.com/cdn/company/2021/footer/mobile/Careers-CTA-Illustration-Mobile_375.png"
      imageUrlDesktop="https://www.nerdwallet.com/cdn/company/2021/footer/desktop/Careers-CTA-Illustration-Desktop.png"
      isSmall={false}
    />
  </div>
);

CompanyPage.displayName = 'Company Page';

export default CompanyPage;
